import { render } from "./RecencyTable.vue?vue&type=template&id=411ce75f"
import script from "./RecencyTable.vue?vue&type=script&lang=js"
export * from "./RecencyTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__